/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_Big2_TitleInputs */

const en_mk_ctrl_big2_title = /** @type {(inputs: Mk_Ctrl_Big2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD ↔ code drift`)
};

const id_mk_ctrl_big2_title = /** @type {(inputs: Mk_Ctrl_Big2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift PRD ↔ kode`)
};

/**
* | output |
* | --- |
* | "PRD ↔ code drift" |
*
* @param {Mk_Ctrl_Big2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_big2_title = /** @type {((inputs?: Mk_Ctrl_Big2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_Big2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_big2_title(inputs)
	return en_mk_ctrl_big2_title(inputs)
});